const CodeBranch = (
    <g>
        <path d="m13.25 5c-.414 0-.75.336-.75.75v1c0 .689-.561 1.25-1.25 1.25h-4.5c-.452 0-.873.12-1.25.314v-2.564c0-.414-.336-.75-.75-.75s-.75.336-.75.75v6.5c0 .414.336.75.75.75s.75-.336.75-.75v-1.5c0-.689.561-1.25 1.25-1.25h4.5c1.517 0 2.75-1.233 2.75-2.75v-1c0-.414-.336-.75-.75-.75z" />
        <path d="m4.75 6.25c1.38071 0 2.5-1.11929 2.5-2.5s-1.11929-2.5-2.5-2.5-2.5 1.11929-2.5 2.5 1.11929 2.5 2.5 2.5z" />
        <path d="m13.25 6.25c1.3807 0 2.5-1.11929 2.5-2.5s-1.1193-2.5-2.5-2.5-2.5 1.11929-2.5 2.5 1.1193 2.5 2.5 2.5z" />
        <path d="m4.75 16.75c1.38071 0 2.5-1.1193 2.5-2.5s-1.11929-2.5-2.5-2.5-2.5 1.1193-2.5 2.5 1.11929 2.5 2.5 2.5z" />
    </g>
);
export { CodeBranch };
